import {OptionToggle} from '~/CreateFabricInvitation/components/OptionToggle';
import {IconWithBadge} from '~/common/components/IconWithBadge/IconWithBadge';
import {MegaphoneIcon} from '~library/svg/MegaphoneIcon';
import {PremiumIcon} from '~library/svg/PremiumIcon';

import {premiumColor} from '~libSass/base/_exports.sass';

export const AdToggle = ({toggleUpsellModal}) => (
  <OptionToggle
    checked
    dataQaId="remove-ads-toggle"
    option="ads"
    icon={
      <IconWithBadge
        mainIcon={<MegaphoneIcon />}
        badgeIcon={<PremiumIcon ratio={0.1} color={premiumColor} />}
      />
    }
    heading="Ads on Invitation"
    description="Turn off to remove ads and upgrade to Premium."
    onChange={() => toggleUpsellModal()}
  />
);
